export const getScopeId = currentInstance => {
  // Fix for render function don't attach data-v-* attr to nested elements
  return { [currentInstance.vnode.scopeId]: '' }
}
